export const categories = [
  {
    slug: "film-edit",
    name: "影视剪辑",
    icon: "ri-film-line",
    description: "精选电影与剧集的高光片段混剪，重温那些令人难忘的银幕瞬间。",
  },
  {
    slug: "short",
    name: "短视频",
    icon: "ri-video-line",
    description: "轻量有趣的短视频内容，用几分钟记录生活里的灵感与美好。",
  },
  {
    slug: "user",
    name: "用户作品",
    icon: "ri-user-star-line",
    description: "来自普通创作者的原创作品，翻唱、短片、手绘与更多脑洞。",
  },
  {
    slug: "music",
    name: "音乐现场",
    icon: "ri-music-2-line",
    description: "演唱会、音乐节与乐器演奏现场，感受声音带来的震撼。",
  },
  {
    slug: "game",
    name: "游戏集锦",
    icon: "ri-gamepad-line",
    description: "赛事名场面、画质对比与实况速通，献给每一位玩家。",
  },
  {
    slug: "knowledge",
    name: "知识科普",
    icon: "ri-lightbulb-line",
    description: "用浅显易懂的方式讲清楚科学、历史与技术的那些事。",
  },
];

export const videos = [
  {
    id: "v01",
    title: "《星际穿越》时空片段混剪：穿越黑洞的那一刻",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20astronaut%20drifting%20through%20a%20glowing%20nebula%20with%20distant%20planets%20and%20soft%20rim%20light%2C%20science%20fiction%20film%20frame%2C%20moody%20atmosphere%2C%20vibrant%20color%20grading&width=800&height=450&seq=card-film-01&orientation=landscape",
    duration: "08:24",
    durationSeconds: 504,
    category: "film-edit",
    tags: ["科幻", "混剪", "经典"],
    uploadDate: "2026-10-08",
    author: "光影拾荒者",
    description:
      "从地球的玉米地到黑洞边缘的五维空间，本次混剪把《星际穿越》中最震撼的时空段落重新串联，感受诺兰镜头下关于时间与爱的浪漫想象。",
    views: 128600,
    likes: 9821,
    featured: true,
  },
  {
    id: "v02",
    title: "燃向动作片高能时刻合集：三分钟肾上腺素拉满",
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20chase%20scene%20with%20explosions%20and%20motion%20blur%2C%20cinematic%20still%2C%20orange%20and%20teal%20lighting%2C%20high%20energy%20composition&width=800&height=450&seq=card-film-02&orientation=landscape",
    duration: "03:12",
    durationSeconds: 192,
    category: "film-edit",
    tags: ["动作", "高能", "合集"],
    uploadDate: "2026-10-06",
    author: "剪辑老张",
    description:
      "把近十年最带感的动作场面剪在一起，追车、近身格斗、爆炸一应俱全，配上紧凑的鼓点节奏，三分钟让你心跳加速。",
    views: 86420,
    likes: 6120,
  },
  {
    id: "v03",
    title: "经典黑白电影对白精选：那些被反复引用的台词",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20black%20and%20white%20cinema%20scene%20with%20vintage%20film%20grain%2C%20moody%20dramatic%20lighting%2C%20retro%20noir%20atmosphere%2C%20elegant%20composition&width=800&height=450&seq=card-film-03&orientation=landscape",
    duration: "11:40",
    durationSeconds: 700,
    category: "film-edit",
    tags: ["黑白", "对白", "文艺"],
    uploadDate: "2026-09-30",
    author: "老电影放映员",
    description:
      "从黑白时代的经典作品中挑选出最打动人的对白片段，配合简洁的解说，带你领略属于那个年代的表达方式与情感浓度。",
    views: 42130,
    likes: 3870,
  },
  {
    id: "v04",
    title: "香港警匪片名场面回顾：霓虹夜色里的江湖",
    cover:
      "https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20film%20city%20street%20at%20night%20with%20neon%20signs%20and%20rain%2C%20cinematic%20still%2C%20cyan%20and%20magenta%20reflections%2C%20moody%20urban%20atmosphere&width=800&height=450&seq=card-film-04&orientation=landscape",
    duration: "07:05",
    durationSeconds: 425,
    category: "film-edit",
    tags: ["港片", "警匪", "经典"],
    uploadDate: "2026-09-27",
    author: "光影拾荒者",
    description:
      "霓虹、雨夜、天台与枪火，香港警匪片用独有的方式讲述着关于情义与选择的江湖故事，本期带你重温那些经典名场面。",
    views: 67540,
    likes: 5230,
  },
  {
    id: "v05",
    title: "城市清晨的第一缕阳光：四点的街头延时",
    cover:
      "https://readdy.ai/api/search-image?query=City%20skyline%20at%20sunrise%20with%20warm%20golden%20light%20and%20soft%20mist%2C%20aerial%20view%2C%20vibrant%20and%20clean%20composition%2C%20hopeful%20morning%20atmosphere&width=800&height=450&seq=card-short-05&orientation=landscape",
    duration: "02:18",
    durationSeconds: 138,
    category: "short",
    tags: ["城市", "延时", "治愈"],
    uploadDate: "2026-10-10",
    author: "会飞的镜头",
    description:
      "用一段延时记录城市从深蓝到金黄的苏醒过程，环卫工、早班车与第一缕阳光依次登场，平凡的一天由此开始。",
    views: 38920,
    likes: 2980,
    featured: true,
  },
  {
    id: "v06",
    title: "街头美食探店三分钟：巷子深处的老味道",
    cover:
      "https://readdy.ai/api/search-image?query=Street%20food%20vendor%20at%20a%20night%20market%20with%20warm%20lantern%20lights%2C%20close%20up%20of%20steaming%20dishes%2C%20vibrant%20appetizing%20colors%2C%20cozy%20evening%20atmosphere&width=800&height=450&seq=card-short-06&orientation=landscape",
    duration: "03:02",
    durationSeconds: 182,
    category: "short",
    tags: ["美食", "探店", "生活"],
    uploadDate: "2026-10-09",
    author: "干饭小分队",
    description:
      "跟着镜头走进老街巷子，找到开了二十年的米粉摊与现炸小吃，热气腾腾之间是城市最真实的烟火气。",
    views: 51230,
    likes: 4460,
  },
  {
    id: "v07",
    title: "治愈系猫咪的一天：阳光、纸箱和打盹",
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20cat%20napping%20in%20a%20sunlit%20cozy%20room%20with%20plants%2C%20soft%20warm%20tones%2C%20gentle%20shadows%2C%20peaceful%20minimal%20lifestyle%20mood&width=800&height=450&seq=card-short-07&orientation=landscape",
    duration: "04:35",
    durationSeconds: 275,
    category: "short",
    tags: ["萌宠", "治愈", "日常"],
    uploadDate: "2026-10-05",
    author: "猫奴日记",
    description:
      "从清晨的伸展到午后的纸箱探险，一只猫的日常就是最好的解压神器，愿这段视频让你慢下来。",
    views: 92450,
    likes: 8870,
  },
  {
    id: "v08",
    title: "极限滑板街拍集锦：城市就是我的场地",
    cover:
      "https://readdy.ai/api/search-image?query=Skateboarder%20performing%20a%20trick%20in%20an%20urban%20plaza%20with%20concrete%20ledges%2C%20dynamic%20motion%2C%20bright%20sunny%20day%2C%20energetic%20street%20style&width=800&height=450&seq=card-short-08&orientation=landscape",
    duration: "05:12",
    durationSeconds: 312,
    category: "short",
    tags: ["运动", "滑板", "街拍"],
    uploadDate: "2026-10-02",
    author: "街头观察员",
    description:
      "栏杆、台阶、花坛，城市的每个角落都能成为滑板手的舞台，本合集收录了几位本地滑手的精彩瞬间。",
    views: 27650,
    likes: 2140,
  },
  {
    id: "v09",
    title: "素人翻唱《海阔天空》：天台上的歌声",
    cover:
      "https://readdy.ai/api/search-image?query=Young%20person%20singing%20into%20a%20microphone%20on%20a%20rooftop%20at%20golden%20hour%2C%20warm%20sunset%20light%2C%20city%20background%2C%20emotional%20sincere%20mood&width=800&height=450&seq=card-user-09&orientation=landscape",
    duration: "05:28",
    durationSeconds: 328,
    category: "user",
    tags: ["翻唱", "音乐", "素人"],
    uploadDate: "2026-10-11",
    author: "阿凯_Kai",
    description:
      "在公司天台用一把吉他和朋友一起唱完了这首歌，没有修音，只有傍晚的风和想唱歌的心情。",
    views: 45670,
    likes: 5120,
    featured: true,
  },
  {
    id: "v10",
    title: "手绘动画短片《风之旅》：一个人做完整部动画",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20hand%20drawn%20animation%20frame%20of%20a%20small%20traveler%20on%20rolling%20green%20hills%20with%20floating%20balloons%2C%20whimsical%20storybook%20art%20style&width=800&height=450&seq=card-user-10&orientation=landscape",
    duration: "06:47",
    durationSeconds: 407,
    category: "user",
    tags: ["动画", "手绘", "原创"],
    uploadDate: "2026-10-07",
    author: "纸上旅行",
    description:
      "用三个月时间逐帧绘制完成的原创短片，讲述一个小小旅行者追着风出发的故事，每一帧都是手绘的温度。",
    views: 62340,
    likes: 7430,
  },
  {
    id: "v11",
    title: "校园微电影《夏天的风》：属于毕业季的告别",
    cover:
      "https://readdy.ai/api/search-image?query=Students%20walking%20through%20a%20schoolyard%20on%20a%20sunny%20summer%20afternoon%20with%20trees%20and%20bicycles%2C%20nostalgic%20warm%20tones%2C%20cinematic%20youth%20mood&width=800&height=450&seq=card-user-11&orientation=landscape",
    duration: "14:20",
    durationSeconds: 860,
    category: "user",
    tags: ["微电影", "青春", "校园"],
    uploadDate: "2026-09-29",
    author: "第三教学楼",
    description:
      "一群学生用一部微电影记录下毕业前的最后一个夏天，关于友情、暗恋和那些没来得及说出口的再见。",
    views: 34780,
    likes: 3260,
  },
  {
    id: "v12",
    title: "一人分饰五角搞笑短剧：房租到期之后",
    cover:
      "https://readdy.ai/api/search-image?query=Comedy%20sketch%20scene%20with%20colorful%20everyday%20apartment%20props%20and%20playful%20bright%20lighting%2C%20funny%20expressive%20mood%2C%20clean%20modern%20interior&width=800&height=450&seq=card-user-12&orientation=landscape",
    duration: "04:08",
    durationSeconds: 248,
    category: "user",
    tags: ["搞笑", "短剧", "创意"],
    uploadDate: "2026-10-03",
    author: "戏精本人",
    description:
      "房东、中介、室友、快递员和主角，五个人其实都是一个人，讲述房租涨价那天发生的一连串乌龙事件。",
    views: 78320,
    likes: 8120,
  },
  {
    id: "v13",
    title: "音乐节现场万人合唱：那晚我们一起唱到哑",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20festival%20crowd%20with%20bright%20stage%20lights%20and%20hands%20raised%20at%20night%2C%20warm%20orange%20glow%2C%20energetic%20live%20concert%20atmosphere&width=800&height=450&seq=card-music-13&orientation=landscape",
    duration: "09:36",
    durationSeconds: 576,
    category: "music",
    tags: ["音乐节", "现场", "合唱"],
    uploadDate: "2026-10-12",
    author: "前排选手",
    description:
      "站在人群中记录下全场大合唱的瞬间，灯光、掌声与跑调的歌声混在一起，这大概就是现场音乐的意义。",
    views: 105300,
    likes: 9450,
    featured: true,
  },
  {
    id: "v14",
    title: "钢琴独奏《月光》：深夜琴房里的一束光",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20piano%20on%20a%20dark%20stage%20with%20a%20single%20soft%20spotlight%2C%20elegant%20minimal%20composition%2C%20moody%20classical%20concert%20atmosphere&width=800&height=450&seq=card-music-14&orientation=landscape",
    duration: "06:02",
    durationSeconds: 362,
    category: "music",
    tags: ["钢琴", "古典", "独奏"],
    uploadDate: "2026-09-25",
    author: "琴房夜话",
    description:
      "贝多芬的《月光奏鸣曲》第一乐章，用最简单的旋律讲述最细腻的情绪，适合在深夜安静地听完。",
    views: 29840,
    likes: 3480,
  },
  {
    id: "v15",
    title: "民谣吉他弹唱合集：窗外下着雨的下午",
    cover:
      "https://readdy.ai/api/search-image?query=Acoustic%20guitar%20leaning%20by%20a%20window%20with%20warm%20sunset%20light%20and%20rain%20drops%2C%20cozy%20intimate%20mood%2C%20soft%20film%20tones&width=800&height=450&seq=card-music-15&orientation=landscape",
    duration: "12:18",
    durationSeconds: 738,
    category: "music",
    tags: ["民谣", "吉他", "弹唱"],
    uploadDate: "2026-09-22",
    author: "南方的南",
    description:
      "整理了几首常弹的民谣作品，没有华丽编曲，只有一把吉他和窗外的雨声，愿你觉得舒服。",
    views: 33410,
    likes: 2960,
  },
  {
    id: "v16",
    title: "电子音乐节高能现场：跟着节拍一起跳动",
    cover:
      "https://readdy.ai/api/search-image?query=Electronic%20music%20concert%20with%20neon%20lights%20and%20laser%20beams%20over%20a%20dancing%20crowd%2C%20vibrant%20colorful%20atmosphere%2C%20high%20energy%20night%20scene&width=800&height=450&seq=card-music-16&orientation=landscape",
    duration: "07:54",
    durationSeconds: 474,
    category: "music",
    tags: ["电子", "电音", "现场"],
    uploadDate: "2026-09-20",
    author: "低音爱好者",
    description:
      "灯光与鼓点同步炸开的瞬间，整片场地都在震动，本期记录了一场难忘的电子音乐夜。",
    views: 41870,
    likes: 4120,
  },
  {
    id: "v17",
    title: "开放世界游戏画质对比：次世代到底强在哪",
    cover:
      "https://readdy.ai/api/search-image?query=Open%20world%20video%20game%20landscape%20with%20mountains%20and%20a%20glowing%20sunset%2C%20digital%20art%20style%2C%20rich%20detail%2C%20cinematic%20game%20graphics&width=800&height=450&seq=card-game-17&orientation=landscape",
    duration: "10:26",
    durationSeconds: 626,
    category: "game",
    tags: ["画质", "对比", "次世代"],
    uploadDate: "2026-10-11",
    author: "帧数研究所",
    description:
      "把同一款开放世界游戏在不同平台与画质设定下的表现放在一起对比，光影、材质与帧率的差异一目了然。",
    views: 88720,
    likes: 7240,
  },
  {
    id: "v18",
    title: "电竞赛事名场面集锦：加时赛最后一秒",
    cover:
      "https://readdy.ai/api/search-image?query=Esports%20arena%20with%20large%20screens%2C%20stage%20lights%20and%20a%20packed%20audience%2C%20neon%20blue%20and%20purple%20lighting%2C%20excited%20competitive%20atmosphere&width=800&height=450&seq=card-game-18&orientation=landscape",
    duration: "08:40",
    durationSeconds: 520,
    category: "game",
    tags: ["电竞", "赛事", "集锦"],
    uploadDate: "2026-10-09",
    author: "上分之路",
    description:
      "从逆风翻盘到最后一秒的绝杀，本期集锦收录了本赛季最让人热血沸腾的赛事瞬间，建议搭配零食观看。",
    views: 96310,
    likes: 8690,
    featured: true,
  },
  {
    id: "v19",
    title: "独立游戏通关实况：一个人做出来的神作",
    cover:
      "https://readdy.ai/api/search-image?query=Pixel%20art%20game%20scene%20with%20an%20adventure%20theme%2C%20colorful%20retro%20style%2C%20charming%20handmade%20indie%20game%20aesthetic&width=800&height=450&seq=card-game-19&orientation=landscape",
    duration: "21:15",
    durationSeconds: 1275,
    category: "game",
    tags: ["独立游戏", "实况", "攻略"],
    uploadDate: "2026-10-01",
    author: "像素旅人",
    description:
      "一款由单人开发完成的独立游戏，画面朴素但玩法巧妙，本期带来完整的通关流程与隐藏关卡解析。",
    views: 31290,
    likes: 2760,
  },
  {
    id: "v20",
    title: "沙盒建造大神作品展：把整座城市搬进游戏",
    cover:
      "https://readdy.ai/api/search-image?query=Sandbox%20building%20game%20with%20creative%20architecture%20and%20a%20detailed%20city%20made%20of%20blocks%2C%20vibrant%20colorful%20render%2C%20isometric%20view&width=800&height=450&seq=card-game-20&orientation=landscape",
    duration: "13:48",
    durationSeconds: 828,
    category: "game",
    tags: ["沙盒", "建造", "作品展"],
    uploadDate: "2026-09-26",
    author: "方块建筑师",
    description:
      "玩家们在沙盒游戏里复刻了城市地标、交通网络甚至樱花季，本期带你参观这些令人惊叹的虚拟建筑作品。",
    views: 37960,
    likes: 3320,
  },
  {
    id: "v21",
    title: "三分钟看懂量子力学：不确定的世界",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20science%20visualization%20with%20glowing%20particles%20and%20wave%20patterns%20on%20a%20dark%20background%2C%20futuristic%20physics%20concept%20art%2C%20luminous%20teal%20and%20gold&width=800&height=450&seq=card-know-21&orientation=landscape",
    duration: "03:20",
    durationSeconds: 200,
    category: "knowledge",
    tags: ["物理", "科普", "量子"],
    uploadDate: "2026-10-10",
    author: "睡前科普",
    description:
      "用最通俗的比喻把量子叠加、观测与不确定性讲明白，三分钟带你入门这个既迷人又反直觉的领域。",
    views: 71320,
    likes: 6980,
  },
  {
    id: "v22",
    title: "宇宙到底有多大：从地球到可观测边界",
    cover:
      "https://readdy.ai/api/search-image?query=Spiral%20galaxy%20surrounded%20by%20thousands%20of%20stars%20in%20deep%20space%2C%20awe%20inspiring%20scale%2C%20deep%20blue%20and%20gold%20cosmic%20atmosphere%2C%20ultra%20detailed&width=800&height=450&seq=card-know-22&orientation=landscape",
    duration: "09:12",
    durationSeconds: 552,
    category: "knowledge",
    tags: ["宇宙", "天文", "科普"],
    uploadDate: "2026-10-04",
    author: "星空望远镜",
    description:
      "从地球出发，一层层放大到星系、星系团乃至可观测宇宙的边界，感受人类尺度与宇宙尺度之间的巨大落差。",
    views: 82640,
    likes: 7710,
    featured: true,
  },
  {
    id: "v23",
    title: "古代文明未解之谜：那些无法解释的建筑",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20stone%20ruins%20with%20mysterious%20carvings%20under%20golden%20afternoon%20light%2C%20archaeological%20exploration%20mood%2C%20warm%20earthy%20tones&width=800&height=450&seq=card-know-23&orientation=landscape",
    duration: "11:05",
    durationSeconds: 665,
    category: "knowledge",
    tags: ["历史", "考古", "未解之谜"],
    uploadDate: "2026-09-24",
    author: "历史放大镜",
    description:
      "精确到毫米的石块拼接、与天象对应的布局，这些古代建筑至今仍让研究者困惑，本期带你一探究竟。",
    views: 54870,
    likes: 4980,
  },
  {
    id: "v24",
    title: "人工智能如何改变生活：一天里的十个瞬间",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20smart%20city%20with%20holographic%20interfaces%20and%20glowing%20data%20streams%2C%20technology%20concept%20art%2C%20clean%20blue%20and%20amber%20lighting&width=800&height=450&seq=card-know-24&orientation=landscape",
    duration: "07:32",
    durationSeconds: 452,
    category: "knowledge",
    tags: ["人工智能", "科技", "生活"],
    uploadDate: "2026-09-21",
    author: "睡前科普",
    description:
      "从早晨的语音助手到深夜的推荐算法，人工智能已经悄悄融入日常，本期用十个真实场景讲讲它的影响。",
    views: 64150,
    likes: 5890,
  },
];

export const heroSlides = [
  {
    videoId: "v01",
    title: "《星际穿越》时空片段混剪",
    subtitle: "穿越黑洞的那一刻，时间与爱一起被拉长。本期精选科幻电影中最震撼的时空段落，带你重温银幕上的浪漫想象。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20astronaut%20walking%20across%20a%20glowing%20alien%20desert%20with%20two%20moons%20in%20the%20sky%2C%20dramatic%20golden%20and%20teal%20color%20grading%2C%20epic%20science%20fiction%20atmosphere&width=1920&height=800&seq=hero-bitebi-01&orientation=landscape",
    label: "精选专题",
  },
  {
    videoId: "v13",
    title: "音乐节现场万人合唱",
    subtitle: "灯光、掌声与跑调的歌声混在一起，站在人群中记录下全场大合唱的瞬间，这大概就是现场音乐的意义。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20shot%20of%20an%20outdoor%20music%20festival%20at%20dusk%20with%20a%20huge%20crowd%20and%20bright%20stage%20lights%2C%20warm%20orange%20glow%2C%20energetic%20live%20concert%20atmosphere%2C%20cinematic&width=1920&height=800&seq=hero-bitebi-02&orientation=landscape",
    label: "热门推荐",
  },
  {
    videoId: "v18",
    title: "电竞赛事名场面集锦",
    subtitle: "从逆风翻盘到最后一秒的绝杀，本期集锦收录了本赛季最让人热血沸腾的赛事瞬间。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20shot%20of%20a%20fantasy%20open%20world%20landscape%20with%20floating%20islands%20and%20a%20glowing%20sunset%20sky%2C%20vivid%20videogame%20concept%20art%20atmosphere%2C%20highly%20detailed&width=1920&height=800&seq=hero-bitebi-03&orientation=landscape",
    label: "赛事集锦",
  },
  {
    videoId: "v22",
    title: "宇宙到底有多大",
    subtitle: "从地球出发，一层层放大到可观测宇宙的边界，感受人类尺度与宇宙尺度之间的巨大落差。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cosmic%20view%20of%20a%20spiral%20galaxy%20surrounded%20by%20thousands%20of%20stars%20in%20deep%20space%2C%20awe%20inspiring%20scale%2C%20deep%20blue%20and%20gold%20cosmic%20atmosphere&width=1920&height=800&seq=hero-bitebi-04&orientation=landscape",
    label: "知识科普",
  },
  {
    videoId: "v10",
    title: "手绘动画短片《风之旅》",
    subtitle: "用三个月逐帧绘制完成的原创短片，讲述一个小小旅行者追着风出发的故事，每一帧都是手绘的温度。",
    image:
      "https://readdy.ai/api/search-image?query=Hand%20drawn%20animation%20style%20wide%20landscape%20with%20rolling%20green%20hills%2C%20a%20small%20traveler%20and%20floating%20balloons%20under%20a%20warm%20sky%2C%20whimsical%20storybook%20atmosphere&width=1920&height=800&seq=hero-bitebi-05&orientation=landscape",
    label: "用户作品",
  },
];

export const trendingTags = [
  "混剪",
  "经典",
  "治愈",
  "现场",
  "电竞",
  "科普",
  "翻唱",
  "运动",
  "美食",
];